import { z } from 'zod';
import { UseFormReturn } from 'react-hook-form';
import { QuoteFeeType } from '@trnsact/trnsact-shared-types';
import { ListingForm } from 'components/shared/TableListing/types';
import { CustomerVisibility } from 'modules/dealSheet/enums';

import { ChargeType } from '../constants';
import { priceSchema } from '../../quote/model/schema';

export enum ChargeAttachType {
  Equipment = 'Equipment',
  Invoice = 'Invoice',
}

export type ChargeParentKind = 'charge' | 'equipment';

export interface ChargeBucketRef {
  id: string;
  type: ChargeAttachType;
}

export type BasePrice = z.infer<typeof priceSchema>;

export interface Charge {
  /** Entity id */
  id?: string;

  /** Nested relation */
  parentId?: string | null;
  parentType?: ChargeParentKind;
  customerVisibility?: CustomerVisibility;

  /**
   * The bucket (equipment or invoice) this charge lives in.
   */
  groupBucket: ChargeBucketRef;

  label: string;
  amount?: number;
  price: BasePrice;
  type: QuoteFeeType;
  isTaxable?: boolean;
  financeType: string;
  amountType?: string;
  description?: string;
  isFromCommonRules?: boolean;
}

export interface ChargeListingContext {
  form: UseFormReturn<ListingForm<Charge>>;
  onRemoveRow: (index: number) => void;
}

export interface ChargesEquipmentDialogData {
  onOpenCreateChargeDialog: VoidFunction;
  onConfirm: (charges: Omit<Charge, 'groupBucket'>[]) => void;
}

export interface CreateChargeDialogData {
  onConfirm: (newChargeItem: { category: ChargeType; name: string }) => void;
}
